import { motion } from 'framer-motion';
import * as React from 'react';

export const TopRankState = ({
  icon,
  label,
  value,
  color,
}: {
  icon: React.ReactNode;
  label: string;
  value: string;
  color: string;
}) => (
  <motion.div
    whileHover={{ y: -4 }}
    className="glass glass-border rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-300"
  >
    <div
      className={`inline-flex p-2 rounded-lg bg-gradient-to-br ${color} text-white mb-3`}
    >
      {icon}
    </div>
    <div className="text-sm text-gray-600 mb-1">{label}</div>
    <div className="text-2xl font-bold text-gray-900">{value}</div>
  </motion.div>
);

